import { isDefined } from "@clipboard-health/util-ts";
import { useWorkerProfilePicture } from "@src/appV2/Agents/api/useWorkerProfilePicture";
import { type WorkplaceCommentType } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";

import { Reaction } from "../types";
import { WorkplaceReviewCommentCompactCard } from "./CompactCard";

interface WorkplaceReviewCommentCompactCardProps {
  comment: WorkplaceCommentType;
  workplaceId: string;
  onLikeChanged: (comment: WorkplaceCommentType) => void;
  onClick?: () => void;
}

export function WorkplaceReviewCommentCompactCardContainer(
  props: WorkplaceReviewCommentCompactCardProps
) {
  const { comment, workplaceId, onLikeChanged, onClick } = props;
  const { createdAt, workerInfo, text, workerReaction, aggregates } = comment.attributes;
  const { id: workerId, name: workerName } = workerInfo;

  const { data: profilePicture, isInitialLoading: isProfilePictureLoading } =
    useWorkerProfilePicture(String(workerId), {
      enabled: isDefined(workerId),
    });

  return (
    <WorkplaceReviewCommentCompactCard
      commentId={comment.id}
      commentText={text}
      createdAtIso={createdAt}
      totalLikes={aggregates.totalLikes}
      workerName={workerName}
      isLiked={workerReaction === Reaction.LIKE}
      profilePictureUrl={profilePicture?.distribution_url}
      isLoadingProfilePicture={isProfilePictureLoading}
      workplaceId={workplaceId}
      maxLines={8}
      onLikeChanged={onLikeChanged}
      onClick={onClick}
    />
  );
}
